import React from "react";
import { AlertTriangle, LifeBuoy } from "lucide-react";
import { useT } from "@/context/I18nContext";
import { Link } from "react-router-dom";

/** A calm, non-flashing crisis banner. Copy stays warm and actionable. */
export default function CrisisBanner({ children, testId = "crisis-banner" }) {
  const t = useT();
  return (
    <div
      className="rounded-2xl border-l-4 border-rust-500 bg-rust-500/5 p-4 flex items-start gap-3"
      data-testid={testId}
    >
      <div className="h-9 w-9 rounded-xl bg-rust-500/10 flex items-center justify-center shrink-0">
        <AlertTriangle className="h-4 w-4 text-rust-600" strokeWidth={1.75} />
      </div>
      <div className="flex-1">
        <div className="font-heading text-ink-900 text-base">{t("client.ifCrisis")}</div>
        <div className="text-sm text-ink-700 mt-0.5">{t("client.ifCrisisSub")}</div>
        {children}
      </div>
      <Link
        to="/app/safety"
        data-testid="crisis-banner-link"
        className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-rust-500 text-white px-3.5 py-1.5 text-sm font-medium hover:bg-rust-600 transition"
      >
        <LifeBuoy className="h-4 w-4" strokeWidth={1.75} />
        {t("client.safetyTitle")}
      </Link>
    </div>
  );
}
